
import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

export enum Alignment {
	VERTICAL = 'btn-group--vertical',
	HORIZONTAL = 'btn-group--horizontal',
}

export enum Sizing {
	GROW = 'btn-group--grow-elements',
	STATIC = 'btn-group--static-elements',
}

export interface IButtonGroupProps {
	className?: string;
	alignment?: Alignment;
	sizing?: Sizing;
	innerProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
	children: React.ReactNode;
}

@observer
export class ButtonGroup extends React.Component<IButtonGroupProps> {
	public render() {
		const {
			alignment,
			children,
			className,
			innerProps,
			sizing,
		} = this.props;
		const sectionProps = innerProps ?? {};

		const classes = classNames(
			'btn-group',
			sectionProps.className,
			alignment,
			sizing,
			className,
		);

		return (
			<section {...innerProps} className={classes}>
				{children}
			</section>
		);
	}
}
